export default __webpack_public_path__ + "static/revolutionizing-retail-f18014119c5dd12d612566c6ca969ffd.png";